import { createSlice } from "@reduxjs/toolkit";

export interface bartenders {
    isChanged: false;

}

const initialState: bartenders = {
    isChanged: false,
};


const formSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        formStateChange: (state, action) => {
            state.isChanged = action.payload;
        }
    },

});

export const { formStateChange } = formSlice.actions;
export default formSlice.reducer;
